// extracted by mini-css-extract-plugin
export default {"player":"PlayerUI_player__+FRF2"};